module.exports = __webpack_public_path__ + "static/media/Museum.ef7a34a7.png";